import ArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded'
import ArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded'
import SaveRoundedIcon from '@mui/icons-material/SaveRounded'
import { Button } from '@mui/material'
import { useAuthContext } from 'contexts/auth.context'
import { hearingFunctionalities } from 'utils/helpers/funcionalidades'
import { FC } from 'react'

type StepButtonGroupProps = {
  isFirstStep: boolean
  isLastStep: boolean
  onPrev?: () => void
  onNext?: () => void
  onSaveDraft?: () => void
  onFinish?: () => void
  prevButtonLabel?: string
  nextButtonLabel?: string
  isFinalized?: boolean
}

const StepButtonGroup: FC<StepButtonGroupProps> = ({
  isFirstStep,
  isLastStep,
  onPrev,
  onNext,
  onSaveDraft,
  onFinish,
  prevButtonLabel,
  nextButtonLabel,
  isFinalized,
}) => {
  const { handleHasPermission } = useAuthContext()

  return (
    <>
      {!isFirstStep && (
        <Button
          startIcon={<ArrowLeftRoundedIcon />}
          color='secondary'
          onClick={onPrev}
          sx={{ pl: 2, pr: 2 }}
        >
          {prevButtonLabel}
        </Button>
      )}

      {!isLastStep && (
        <Button
          variant='contained'
          startIcon={<SaveRoundedIcon />}
          color='info'
          onClick={onSaveDraft}
          sx={{ pl: 2, pr: 2 }}
        >
          Salvar Rascunho
        </Button>
      )}

      {!isLastStep && (
        <Button
          color='secondary'
          variant='contained'
          endIcon={<ArrowRightRoundedIcon />}
          onClick={onNext}
          sx={{ pl: 2, pr: 2 }}
        >
          {nextButtonLabel}
        </Button>
      )}

      {!isFinalized && isLastStep && handleHasPermission(hearingFunctionalities.finalizar) && (
        <Button
          variant='contained'
          startIcon={<SaveRoundedIcon />}
          color='secondary'
          onClick={onFinish}
          sx={{ pl: 2, pr: 2 }}
        >
          Finalizar Oitiva
        </Button>
      )}
    </>
  )
}

export default StepButtonGroup
